<script setup lang="ts">
const props = defineProps({
  criteriaInstance: {
    type: Object as PropType<CriteriaInstance>,
    required: true,
  },
  criteria: {
    type: Object as PropType<ChecklistCriteria>,
    required: true,
  },
});

const documentId = inject("documentId") as any;

const thesaurusStore = useDocumentThesaurusStore(documentId);
const { underlinedWords } = storeToRefs(thesaurusStore);

const criteriaSelfAssessmentSteps = computed(() => {
  return props.criteria.selfAssessmentSteps ?? [];
});

const selfAssessmentStepAttributes = computed(() => {
  return criteriaSelfAssessmentSteps.value
    .map((step) => {
      return step.criteriaAttribute.attribute;
    })
    .filter((attribute) => {
      return attribute != undefined && attribute.includes("dressup");
    });
});

const dressUpsToTag = computed(() => {
  if (selfAssessmentStepAttributes.value.length == 0) return [];

  if (underlinedWords.value.length == 0) return [];

  return underlinedWords.value.filter((word) => {
    return Object.keys(word.attributes).some((attribute) => {
      return (
        attribute.toLowerCase().includes("dressup") &&
        selfAssessmentStepAttributes.value.includes(attribute)
      );
    });
  });
});
</script>

<template>
  <div v-auto-animate>
    <div
      v-if="dressUpsToTag.length > 0"
      class="flex flex-row gap-2 flex-wrap mb-4 pl-2"
    >
      <DocumentStudentEditingDressupsSelector
        v-for="dressUp in dressUpsToTag"
        :key="dressUp.startIndex"
        :dress-up="dressUp"
      />
    </div>
  </div>
</template>

<style scoped></style>
